export default "__VITE_ASSET__BI6YTRVe__"